import { reporter } from '~/@common/utils/errorReporting/reporter'

import { TOAST_STRING } from '../constants/strings'
import { toastService } from './toast.service'

interface ErrorHandlerOptions {
  message?: string
  preventToast?: boolean
  useRemoteLogging?: boolean
  logType?: 'error' | 'warn'
}

class ErrorHandlerService {
  handle(err: unknown, options: ErrorHandlerOptions = {}) {
    const {
      message = TOAST_STRING.error,
      preventToast,
      useRemoteLogging,
      logType = 'error',
    } = options

    switch (logType) {
      case 'error':
        console.error(err)
        break
      case 'warn':
        console.warn(err)
        break
    }

    if (!preventToast) {
      toastService.error(message, { isSystemError: true })
    }

    if (useRemoteLogging) {
      // Error 가 아닌 값(문자열·객체)도 파이프라인이 메시지로 정규화한다. 보낼지는 파이프라인이 정한다.
      reporter.capture(err, { mechanism: 'manual' })

      // else if (err instanceof SyntaxError) {
      //   // handle SyntaxError
      // } else if (err instanceof Error) {
      //   // handle Error
      // }
    }
  }
}

export const errorHandlerService = new ErrorHandlerService()
